import React from 'react';
import Flickity from 'react-flickity-component';
import "../styles/WhatsNewSlider.css";
import { useNavigate } from 'react-router-dom';

const WhatsNewSlider = ({ items }) => {
  const navigate = useNavigate();

  const flickityOptions = {
    cellAlign: "left",
    freeScroll: true,
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true,
  };

  const handleNavigation = (link) => {
    navigate(`${link}`);
  };

  return (
    <div className="w-full flex justify-center my-8 md:my-12">
      {/* Centered container */}
      <div className="max-w-6xl w-full flex flex-col md:flex-row md:items-center px-4 md:px-8 lg:px-12">
        {/* Left title */}
        <div className="md:w-2/12 w-full mb-4 md:mb-0 flex justify-center md:justify-start">
          <h2 className="md:text-2xl text-lg text-left uppercase">What's New</h2>
        </div>

        {/* Carousel with spacing */}
        <div className="md:w-10/12 w-full mt-2 md:mt-0 md:ml-6">
          <Flickity className="carousel" elementType="div" options={flickityOptions}>
            {items?.map((item, index) => (
              <div
                key={index}
                className="carousel-cell flex flex-col items-center cursor-pointer mx-2"
                onClick={() => handleNavigation(item.link)}
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full overflow-hidden flex items-center justify-center bg-gray-200 border-2 shadow-md hover:scale-105 transition-transform">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-center text-xs sm:text-sm md:text-base w-16 sm:w-20 md:w-24 mt-2 truncate">
                  {item.name}
                </p>
              </div>
            ))}
          </Flickity>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewSlider;
